import dateFormat from 'dateformat'

export default {
  filters: {
    openSkillType: function (type) {
      let str = ''
        if (type == 0) {
            str = '原始技能'
        } else if (type == 1) {
            str = '自定义'
        } else if (type == 2) {
            str = '智能家居'
        } else {
            str = '自定义'
        }
      // switch (type) {
      //   case '0' :
      //     str = '原始技能'
      //     break;
      //   case '1' :
      //     str = '自定义'
      //     break;
      //   case '2' :
      //     str = '智能家居'
      //     break;
      // }
      return str
    },
    audited_type: function (online) { // 审核状态
      let str = ''
      switch (online) {
        case -1 :
          str = '冻结'
          break;
        case 0 :
          // str = '未审核'
          str = '开发中'
          break;
        case 1 :
          str = '拒绝审核'
          break;
        case 2 :
          str = '通过审核'
          break;
        case 3 :
          str = '审核中'
          break;
        case 4 :
          str = '拒绝上线'
          break;
        case 5 :
          str = '已上线'
          break;
        case 6 :
          str = '已下线'
          break;
        case 7 :
          str = '已删除'
          break;
        case 8 :
          str = '强制下线'
          break;
      }
      return str
    },
    msg_type: function (item) {
      let str = ''
      if (item.msg_type == 'reject') {
        str = '拒绝审核'
      } else if (item.msg_type == 'normal'){
        if (item.title) {
          str = item.title
        } else {
          str = '普通消息'
        }
      } else {
        str = '普通消息'
      }
      // switch (item.msg_type) {
      //   case 'reject' :
      //     str = '拒绝审核'
      //     break;
      //   case 'normal' :
      //     str = '普通消息'
      //     break;
      // }
      return str
    },
    conversion: function (num) {
      let n = num.toString()
      if (n.length == 4){
        n = n.substr(0,1) + '.' + n.substr(1,1) + 'k'
      } else if (n.length == 5){
        n = n.substr(0,1) + '.' + n.substr(1,2) + 'w'
      } else if (n.length < 4) {
        n = ' <1K'
      }
      return n
    }
  },
  methods: {
    dateFormat,
    // dateFormat_new: function (time, formate = 'yyyy-mm-dd') {
    //   if (typeof (time) == 'undefined') {
    //     return ''
    //   } else {
    //     const eTime = new Date(time * 1000)
    //     return dateFormat(time, formate)
    //   }
    // }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/commonMethods.js